import { render } from "./OnuList.vue?vue&type=template&id=5a875cbc&scoped=true"
import script from "./OnuList.vue?vue&type=script&lang=js"
export * from "./OnuList.vue?vue&type=script&lang=js"

import "./OnuList.vue?vue&type=style&index=0&id=5a875cbc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a875cbc"]])

export default __exports__